import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";

import { Label, Spinner, SpinnerSize } from "@fluentui/react";
import { useEffect, useState } from "react";
import Diagnostics from "./Diagnostics";
import LoggedOutLayout from "./LoggedOutLayout";

const App = () => {
  return (
    <>
      <UnauthenticatedTemplate>
        <LoggedOutLayout />
      </UnauthenticatedTemplate>

      <AuthenticatedTemplate>
        <DelayedDiagnostics />
      </AuthenticatedTemplate>
    </>
  );
};

const DelayedDiagnostics = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return <div>{isVisible ? <Diagnostics /> : <LoggingIn />}</div>;
};

const LoggingIn = () => {
  return (
    <div
      style={{
        width: "100vw",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Spinner size={SpinnerSize.large} />
      &nbsp;&nbsp;&nbsp;
      <Label>Loading...</Label>
    </div>
  );
};

export default App;
